import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=28b413f6&"
import script from "./Hint.vue?vue&type=script&lang=js&"
export * from "./Hint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports